
import { Card, CardHeader, CardContent, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { LensInventory } from "@/types/inventory";

interface LensInfoCardProps {
  lens: LensInventory;
}

export function LensInfoCard({ lens }: LensInfoCardProps) {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'working':
        return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100';
      case 'needs_repair':
        return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100';
      case 'for_parts':
        return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100';
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100';
    }
  };

  const formatStatus = (status: string) => {
    return status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  return (
    <Card className="overflow-hidden">
      <CardHeader className="pb-2">
        <div className="flex justify-between items-center mb-2">
          <CardTitle className="text-2xl">{lens?.brand} {lens?.lens_name}</CardTitle>
          <Badge className={getStatusColor(lens?.status || '')}>
            {formatStatus(lens?.status || '')}
          </Badge>
        </div>
        <CardDescription>{lens?.mount} Mount</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="grid grid-cols-3 gap-2">
            {lens?.serial_number && (
              <>
                <div className="col-span-1 font-medium">Serial No.</div>
                <div className="col-span-2">{lens?.serial_number}</div>
              </>
            )}
            
            {lens?.purchase_date && (
              <>
                <div className="col-span-1 font-medium">Purchased</div>
                <div className="col-span-2">{lens?.purchase_date}</div>
              </>
            )}
            
            {lens?.purchase_price && (
              <>
                <div className="col-span-1 font-medium">Price</div>
                <div className="col-span-2">${lens?.purchase_price}</div>
              </>
            )}
          </div>
          
          {lens?.notes && (
            <div className="pt-4 border-t mt-4">
              <div className="font-medium mb-2">Notes</div>
              <div className="text-sm text-muted-foreground">
                {lens?.notes}
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
